import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'react-material-symbols/rounded';
import store from './store/store';
import { Provider } from 'react-redux';
import { ModalProvider, useModal } from 'component/Modal/ModalProvider';
import { setModalAPI } from 'component/Modal';
import { MaterialSymbolsProvider, MaterialSymbolsPreloader } from 'component/MaterialSymbols';
// Initialize BinusPopinfo notification system
import 'component/BinusPopinfo/notificationAPI';
// import { DataProvider } from './dataContext';
// import reportWebVitals from './reportWebVitals';
import { initGA, trackPageView } from './utils/analytics';
import { useLocation } from 'react-router-dom';

const container = document.getElementById('root');
const root = createRoot(container);
const basename = process.env.REACT_APP_BASE_PATH;

// Initialize Google Analytics
initGA();

if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
  console.error = () => { }
  console.debug = () => { }
}

const PageLanding = lazy(() => import("pages/landing"));
const PageRegister = lazy(() => import("pages/register"));
const PageVerification = lazy(() => import("pages/verification"));
const PageResetPassword = lazy(() => import("pages/reset-password"));
const PageForgotPassword = lazy(() => import("pages/forgot-password"));
const PageArchive = lazy(() => import("pages/archive"));
const PageHall = lazy(() => import("pages/hall"));
const PageThesis = lazy(() => import("pages/thesis"));
const PageLecturer = lazy(() => import("pages/lecturer"));

// Component untuk menginisialisasi Modal API
function AppWithModal() {
  const { openModal, closeModal, closeAll, closeLastModal } = useModal();
  const location = useLocation();

  React.useEffect(() => {
    setModalAPI({ openModal, closeModal, closeAll, closeLastModal });
  }, [openModal, closeModal, closeAll, closeLastModal]);

  // Track page view on route change
  React.useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <Suspense fallback={<div className='page-loader' />}>
      <Routes>
        <Route path='/' element={<PageLanding />} />
        <Route path='/register' element={<PageRegister />} />
        <Route path='/verification/:token' element={<PageVerification />} />
        <Route path='/reset-password/:token' element={<PageResetPassword />} />
        <Route path='/forgot-password' element={<PageForgotPassword />} />
        <Route path='/faculty/:faculty_code' element={<PageArchive />} />
        <Route path='/faculty/:faculty_code/:period_slug' element={<PageArchive />} />
        <Route path='/thesis/:slug' element={<PageThesis />} />
        <Route path='/lecturer/:lecturer_code' element={<PageLecturer />} />
        <Route path='/hall' element={<PageHall />} />
      </Routes>
    </Suspense>
  );
}

root.render(
  <Provider store={store}>
    <BrowserRouter basename={basename}>
      <MaterialSymbolsProvider>
        <MaterialSymbolsPreloader>
          <ModalProvider>
            <AppWithModal />
          </ModalProvider>
        </MaterialSymbolsPreloader>
      </MaterialSymbolsProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
